import React from "react";
import bannerImage from "./Resources/banner.jpg";
import Banner from "./Components/Banner";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import NavigationBar from "./Components/NavigationBar";

import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";
import YouTube from "react-youtube";

import goldenTeacherImage from "./Resources/goldenTeacher.jpg";
import psyfunktionImage from "./Resources/psyfunktion.jpg";
import psyfunktion2Image from "./Resources/psyfunktion2.png";
import ocrImage from "./Resources/ocr.jpg";
import styleRadioImage from "./Resources/styleradio.jpg";

import "@fortawesome/fontawesome-free/css/all.min.css";

function App() {
  // const opts = {
  //   height: '250',
  //   width: '450',
  //   playerVars: {
  //     // https://developers.google.com/youtube/player_parameters
  //     autoplay: 1,
  //   },
  // };

  return (
    <>
      <NavigationBar />
      <Banner pageTitle="ღ ₲ØⱠĐɆ₦ ₮Ɇ₳₵ⱧɆⱤ ღ" imageUrl={bannerImage} />

      <section
        className="d-flex justify-content-center"
        style={{ padding: "10px" }}
      >
        <Button href="gigs" variant="info">
          Gigs
        </Button>
      </section>
      <section className="video-responsive">
        <YouTube videoId="bM3ta9osTvs" />
      </section>
      <hr />
      <Container className="d-flex justify-content-center">
        <img
          style={{ width: "100%", maxWidth: "650px" }}
          src={goldenTeacherImage}
        />
      </Container>
      <hr />
      <hr />
      <Container className="justify-content-center">
        <Container className="justify-content-center text-center">
          <p>💥🥹💥🌹 😊•☆ 🌈🎪🌈 *•☆•☆</p>
          <h1>Golden teacher</h1>
          <p>´•.✨•☆🎧 *•☆🤍🪐</p>
        </Container>

        <Container className="justify-content-center">
          <p>
            I began my DJ career playing vinyl in clubs in my hometown Norwich
            in 1995, where my first gig was in a bar called the lounge,
            frequented with celebrities from the local theatre royal. I played
            Tech/Min tech, House, Lounge, Garage, Electro breaks, Jungle, Old
            School and Drum and Bass, it was the 1990’s and the scene was huge.
            My DJ name was Miss Adventure, mainly known for D & B and Jungle, I
            got my name from local record label, and team called Play It By Ear,
            and No Beats Dropped, who were residents our PH at the time.
          </p>
          <p>
            I moved in to radio DJing in 2000 onward - playing for two radio
            stations, Flight 100, and Style Radio.
          </p>
          <br />
          <p>
            I played vinyl at many forest parties in North Norfolk, 1995-2005
            alongside well known clubs.
          </p>
          <p>
            After a long decade of open air and underground events in the
            forest, in Norfolk. Finally Planet Yes and Inna Field sound systems
            moved to Andalusia, which was the last of our parties for many.
          </p>
          <br />
          <p>
            I decided to go to London to meet people, start a new era… at a
            Parvati Records party in 2013 - I met the founders of “This Is
            Sparta” - “Butterfly effect”, (I became PsyChe) they were to become
            good promoter creating companies like “Visual Architects” - and
            great success future, they talked of their dream of pretty
            psychedelic parties, and made them real. I helped play for these
            parties for many years to come.
          </p>
          <p>
            SOS and Alternative Waves were a big players in our first
            psychedelic gigs in London in 2013.
          </p>
          <p>Since then I have worked for the psychedelic scene.</p>
          <p>
            Fond memories being my first forest party gig with Psykia in 2014 -
            then Psygasum 2015, and many more well known underground DJ and
            party names.
          </p>
          <p>
            Recently I changed my name from PsyChe to launch a new career, I
            became "Golden Teacher" in 2023 to allow more versatile styles.
          </p>
          <br />
          <p>
            During the 28+ years I have played for - I’ve covered all formats of
            music, from Vinly to learning production, to CDJ then USB’s.
          </p>
          <p>
            In Jan 2023 - I had the pleasure of teaming up with PSY Funktion
            Record.
          </p>
          <p>And some music from Organik Circus Records</p>
          <p>In Feb 2023 I joined Style Radio, reformed DAB</p>
          <br />
          <p>
            My music is happy uplifting and has a sense of humour - I play Post
            modern music, experimental psy, forest pry, with some
            techno/experimental woven in…my sound is unique, brings a smile to
            all dance doors
          </p>
          <p>
            I’m inspired by emerging artists, labels and production, new sounds,
            and what inner energies connects us with psyche to dance.
          </p>
          <p>Forest, Psycore and Experimental bpm 150-350</p>
          <br />
          <br />
        </Container>
        <Container className="justify-content-center text-center">
          <p>´•.✨•☆🎧 *•☆🤍🪐</p>
          <br />
          <p>
            <a
              href="https://www.facebook.com/DJpsycheliveonradio"
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
          </p>
          <br />
        </Container>
      </Container>
      <hr />
      <Container className="text-center">
        <h1>Representing</h1>
        <Container className="justify-content-center">
          <Image src={ocrImage} fluid />;
          <Image src={styleRadioImage} fluid />;
        </Container>
      </Container>
    </>
  );
}

export default App;
